import * as React from 'react';
import { Link } from 'react-router-dom';

interface FooterProps { appName: string; }

export const Footer = (props: FooterProps) => (
  <footer className="layout-footer">
    <header className="layout-footer-content">
      <p className="app-name"><Link to="/">{props.appName}</Link></p>

      <div className="copyright">
        Copyright &copy; The Regents of the University of California, Davis campus. All rights reserved.
      </div>
    </header>
  </footer>
);



// WEBPACK FOOTER //
// ./src/gs-core/client/react/layout/Footer.tsx